import { z } from '@hono/zod-openapi'

// name: 業者名
export const nameZ = z
  .string()
  .openapi({ description: '業者名', example: '株式会社ABC工務店' })
export type name = z.infer<typeof nameZ>

// contactPerson: 担当者名
export const contactPersonZ = z
  .string()
  .nullable()
  .openapi({ description: '業者の担当者名', example: '山田太郎' })
export type contactPerson = z.infer<typeof contactPersonZ>

// 業者カテゴリ
export const CONTRACTOR_CATEGORY_GENERAL = 'general'
export const CONTRACTOR_CATEGORY_INTERIOR = 'interior'
export const CONTRACTOR_CATEGORY_PLUMBING = 'plumbing'
export const CONTRACTOR_CATEGORY_WATER_HEATER = 'water_heater'
export const CONTRACTOR_CATEGORY_AIR_CONDITIONER = 'air_conditioner'
export const CONTRACTOR_CATEGORY_OTHER_APPLIANCES = 'other_appliances'
export const CONTRACTOR_CATEGORY_ELECTRICAL = 'electrical'

export const contractorCategoryZ = z.enum([
  CONTRACTOR_CATEGORY_GENERAL,
  CONTRACTOR_CATEGORY_INTERIOR,
  CONTRACTOR_CATEGORY_PLUMBING,
  CONTRACTOR_CATEGORY_WATER_HEATER,
  CONTRACTOR_CATEGORY_AIR_CONDITIONER,
  CONTRACTOR_CATEGORY_OTHER_APPLIANCES,
  CONTRACTOR_CATEGORY_ELECTRICAL,
])
export type ContractorCategory = z.infer<typeof contractorCategoryZ>

// categories: カテゴリ
export const categoriesZ = z.array(contractorCategoryZ).openapi({
  description:
    '対応カテゴリ（general:総合 / interior:内装 / plumbing:水道 / water_heater:給湯器 / air_conditioner:エアコン / other_appliances:その他設備 / electrical:電気）',
  example: ['plumbing'],
})
export type categories = z.infer<typeof categoriesZ>

// otherCategory: その他カテゴリ
export const otherCategoryZ = z.string().nullable().openapi({
  description: 'categories に該当がない場合の自由記述カテゴリ',
  example: null,
})
export type otherCategory = z.infer<typeof otherCategoryZ>

// 依頼方法
export const REQUEST_METHOD_EMAIL = 'email' as const
export const REQUEST_METHOD_FAX = 'fax' as const
export const REQUEST_METHOD_PHONE = 'phone' as const

export const requestMethodZ = z
  .enum([REQUEST_METHOD_EMAIL, REQUEST_METHOD_FAX, REQUEST_METHOD_PHONE])
  .openapi({
    description: '依頼方法（email:メール / fax:FAX / phone:電話）',
    example: 'phone',
  })
export type requestMethod = z.infer<typeof requestMethodZ>

// contactInfo: 連絡先情報
export const contactInfoZ = z.string().openapi({
  description:
    '連絡先（依頼方法に対応する電話番号 / メールアドレス / FAX番号）',
  example: '03-1234-5678',
})
export type contactInfo = z.infer<typeof contactInfoZ>

// address: 住所
export const addressZ = z
  .string()
  .nullable()
  .openapi({ description: '業者の住所', example: '東京都渋谷区1-2-3' })
export type address = z.infer<typeof addressZ>

// note: 備考
export const noteZ = z.string().nullable().openapi({
  description: '備考（営業時間など）',
  example: '営業時間: 9:00-18:00',
})
export type note = z.infer<typeof noteZ>
